<template>
  <div class="ad-revenue-query">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      
      <el-form :inline="true" :model="form" label-width="90px" @submit.native.prevent>
        <div class="query-form-container">
          <el-row :gutter="15" style="width: 100%;">
            <el-col :span="8">
              <el-form-item label="时间范围" style="width: 100%;">
                <el-date-picker
                  v-model="form.dateRange"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  align="right"
                  :default-time="['00:00:00', '23:59:59']"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :clearable="false"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="广告类型" style="width: 100%;">
                <el-select v-model="form.adType" clearable placeholder="请选择广告类型" style="width: 100%;">
                  <el-option label="激励视频" value="reward"></el-option>
                  <el-option label="激励Feed" value="feed"></el-option>
                  <el-option label="激励Feed1" value="feed1"></el-option>
                  <el-option label="顶部Banner" value="banner_top"></el-option>
                  <el-option label="底部Banner" value="banner_bottom"></el-option>
                  <el-option label="插屏全屏" value="interstitial"></el-option>
                  <el-option label="插屏2" value="interstitial1"></el-option>
                  <el-option label="开屏" value="splash"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用户名" style="width: 100%;">
                <el-input v-model.trim="form.username" clearable placeholder="请输入用户名" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item style="display: flex; align-items: flex-end; height: 100%;">
                <div class="button-group">
                  <el-button type="primary" :loading="loading" @click="handleSearch" icon="el-icon-search">查询</el-button>
                  <el-button @click="handleReset" :disabled="loading" icon="el-icon-refresh">重置</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && !hasTable" description="暂无数据" />
      <div v-else>
        <div class="summary-bar">
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="8">
              <el-card class="summary-card primary animate__animated animate__bounceInLeft">
                <div class="summary-content">
                  <i class="el-icon-wallet summary-icon"></i>
                  <div class="summary-value">{{ totalEcpmDisplay }}</div>
                  <div class="summary-label">总收入</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="summary-card success animate__animated animate__bounceInRight">
                <div class="summary-content">
                  <i class="el-icon-document summary-icon"></i>
                  <div class="summary-value">{{ totalCount }}</div>
                  <div class="summary-label">总条数</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        
        
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在查询..."
          class="animate__animated animate__fadeIn"
        >
          <el-table-column prop="id" label="ID" width="90" align="center"/>
          <el-table-column prop="username" label="用户名" min-width="120" />
          <el-table-column prop="adnName" label="广告平台" min-width="120" />
          <el-table-column prop="adType" label="广告类型" min-width="100" />
          <el-table-column prop="parentId" label="上级ID" min-width="100" />
          <el-table-column prop="ecpm" label="eCPM" min-width="100" />
          <el-table-column prop="transId" label="交易ID" min-width="180" />
          <el-table-column
            prop="isGromoreServerSideVerify"
            label="服务器验证"
            min-width="120"
            :formatter="boolFormatter"
            align="center"
          />
          <el-table-column prop="reason" label="原因" min-width="140" />
          <el-table-column
            prop="createdTime"
            label="创建时间"
            min-width="170"
            :formatter="timeFormatter"
          />
          <el-table-column
            prop="updatedTime"
            label="更新时间"
            min-width="170"
            :formatter="timeFormatter"
          />
        </el-table>
        
        <!-- 分页组件 -->
        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { request } from '@/utils/http.js'

export default {
  name: 'AdRevenueQuery',
  data() {
    return {
      form: {
        dateRange: [],
        username: '',
        adType: ''  // 添加广告类型筛选字段
      },
      loading: false,
      error: '',
      response: null,
      tableData: [],
      // 分页参数
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 添加后端返回的总计数据
      totalCount: 0,
      totalEcpm: 0
    }
  },
  computed: {
    hasTable() {
      return Array.isArray(this.tableData) && this.tableData.length > 0
    },
    totalEcpmDisplay() {
      return this.totalEcpm.toFixed(4)
    }
  },
  methods: {
    pad2(n) {
      return n.toString().padStart(2, '0')
    },
    getTodayStartEnd() {
      const now = new Date()
      const y = now.getFullYear()
      const m = this.pad2(now.getMonth() + 1)
      const d = this.pad2(now.getDate())
      const start = `${y}-${m}-${d} 00:00:00`
      const end = `${y}-${m}-${d} 23:59:59`
      return { start, end }
    },
    pretty(obj) {
      try {
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        return String(obj)
      }
    },
    timeFormatter(row, column, cellValue) {
      if (!cellValue) return ''
      return String(cellValue).replace('T', ' ')
    },
    boolFormatter(row, column, cellValue) {
      return cellValue ? '是' : '否'
    },
    handleReset() {
      const { start, end } = this.getTodayStartEnd()
      this.form.dateRange = [start, end]
      this.form.username = ''
      this.form.adType = ''  // 重置广告类型筛选
      this.tableData = []
      this.response = null
      this.error = ''
      // 重置分页参数
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
      // 重置总计数据
      this.totalCount = 0
      this.totalEcpm = 0
      // 清空图表
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page;
      this.fetchData(false);
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.pageNum = 1; // 重置到第一页
      this.fetchData();
    },
    async handleSearch() {
      // 搜索时重置到第一页
      this.pagination.pageNum = 1;
      // 搜索时清空现有数据
      this.tableData = []
      // 重置总计数据
      this.totalCount = 0
      this.totalEcpm = 0
      await this.fetchData()
    },
    async fetchData() {
      this.error = ''
      this.response = null

      const [start, end] = this.form.dateRange || []
      if (!start || !end) {
        this.error = '请选择时间范围'
        return
      }
      if (new Date(end.replace(' ', 'T')) < new Date(start.replace(' ', 'T'))) {
        this.error = '结束日期不能早于开始日期'
        return
      }

      // 构建URL参数
      let url = `/ADRevenueDataAdmin/getADRevenueDataByDateRange?startDate=${encodeURIComponent(start)}&endDate=${encodeURIComponent(end)}&pageNum=${this.pagination.pageNum}&pageSize=${this.pagination.pageSize}`;
      
      // 如果有广告类型筛选，则添加到URL参数中
      if (this.form.adType) {
        url += `&adType=${encodeURIComponent(this.form.adType)}`;
      }
      
      // 如果有用户名，则添加到请求体中
      const body = this.form.username ? { username: this.form.username } : {};

      this.loading = true
      try {
        // 发送POST请求，参数在URL中，可选的username在请求体中
        const result = await request(url, {
          method: 'POST',
          body: JSON.stringify(body)
        })
        
        // 处理返回的数据
        if (result && typeof result === 'object' && result.data) {
          const data = result.data
          const newRecords = Array.isArray(data.records) ? data.records : []
          
          // 设置表格数据
          this.tableData = newRecords
          
          // 更新分页信息
          this.pagination.total = data.total || 0
          this.pagination.pageSize = data.size || this.pagination.pageSize
          this.pagination.pageNum = data.current || this.pagination.pageNum
          
          // 使用后端返回的总计数据
          this.totalCount = data.total_count || 0
          this.totalEcpm = data.total_ecpm || 0
        } else {
          this.tableData = []
          this.pagination.total = 0
          this.pagination.pageNum = 1
          // 重置总计数据
          this.totalCount = 0
          this.totalEcpm = 0
        }
      } catch (e) {
        this.error = e && e.message ? e.message : '请求出现错误'
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    const { start, end } = this.getTodayStartEnd()
    this.form.dateRange = [start, end]
  },
  mounted() {
    // 页面加载完成后自动执行一次搜索
    this.handleSearch();
  },
}
</script>

<style scoped>
.ad-revenue-query {
  padding: 16px;
}

.query-form-container {
  margin-bottom: 16px;
  width: 100%;
}

.query-form-container .el-form-item {
  margin-bottom: 0;
}

.button-group {
  display: flex;
  gap: 10px;
}

.button-group .el-button {
  margin-left: 0;
}

.summary-card {
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease;
  height: 120px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
}

.summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
}

.summary-card.primary {
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  color: #1976d2;
  border: none;
}

.summary-card.success {
  background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
  color: #388e3c;
  border: none;
}

.summary-content {
  text-align: center;
  /* padding: 18px; */
}

.summary-icon {
  font-size: 24px;
  margin-bottom: 8px;
  display: block;
  color: inherit;
}

.summary-value {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 4px;
}

.summary-label {
  font-size: 13px;
  opacity: 0.8;
  font-weight: normal;
}

.summary-bar {
  margin-bottom: 30px;
}

.error {
  color: #c0392b;
  background: #fdecea;
  border: 1px solid #f5c6cb;
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}

/* Speed up animations */
.el-card.animate__animated,
.el-table.animate__animated {
  --animate-duration: 0.3s;
}
</style>